import {Spin} from "antd";
import {LoadingOutlined} from '@ant-design/icons';
import React from "react";
import './page-loading.less';

export default function PageLoading() {
    let spinIcon = <LoadingOutlined style={{fontSize: '5rem'}} spin />;
    return (
        <div className={'page-loading-wrap'}>
            <Spin indicator={spinIcon} />
        </div>
    )
}
